// extracted by extract-css-chunks-webpack-plugin
module.exports = {"linkButton":"LY6pzsu5dLTi"};